/**
 * Mobile Menu toggle
 *
 * @author Matt Haynes
 * @package Joi Polloi
 *
 */

const mobileNavigation = () => {
    const navToggle = document.getElementById('mobile-navigation-toggle');
    if (!navToggle) return;

    window.addEventListener('resize', () => {
        if (window.innerWidth >= 768) {
            document.body.classList.remove('mobileNavActive');
            navToggle.setAttribute('aria-expanded', 'false');
        }
    });

    navToggle.addEventListener('click', () => {
        const mobileNavActive = document.body.classList.contains('mobileNavActive');
        if (mobileNavActive) {
            document.body.classList.remove('mobileNavActive');
            navToggle.setAttribute('aria-expanded', 'false');
        } else {
            document.body.classList.add('mobileNavActive');
            navToggle.setAttribute('aria-expanded', 'true');
        }
    });
};

export default mobileNavigation;
